import { createContext, useContext } from 'react';
import { setLivelynessChecking } from 'mobx-state-tree';

import { ModalStore } from 'shared/modals/ModalStore';
import companyStore from './CompanyStore';
import jobStore from './JobStore';
import uiStore from './UIStore';
import AppStore from './AppStore';

export const modalStore = ModalStore.create();

const store = AppStore.create({
  companyStore,
  uiStore,
  modalStore,
  jobStore,
});

const AppContext = createContext();

export const AppStoreProvider = ({ children }) => {
  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};
export const useStore = () => useContext(AppContext);

if (process.env.NODE_ENV === 'development') {
  window.store = store;
  setLivelynessChecking('error');
}
